import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Formatter } from "../../utils/formatter";
import { Link } from "../util/Clickable";
import { Image } from "../util/Image";
import { IntlText } from "../util/Text";

class ArticlesList extends Component {
  render = () => {
    if (this.props.articles == null) {
      return (
        <div className="uk-text-center">
          <span data-uk-spinner="ratio: 3"></span>
        </div>
      );
    } else if (this.props.articles.length <= 0) {
      return (
        <div>
          <h3>
            <IntlText id="lists.articles.no" />
          </h3>
        </div>
      );
    }
    const lang = this.props.lang ? this.props.lang : this.props.language.view;
    return (
      <div className="uk-overflow-auto">
        <table className="uk-table uk-table-small uk-table-striped">
          <thead>
            <tr>
              <th className="uk-table-shrink">
                <IntlText id="lists.articles.post_date" />
              </th>
              <th className="uk-table-shrink">
                <IntlText id="lists.articles.thumnail" />
              </th>
              <th className="uk-table-expand">
                <IntlText id="lists.articles.description" />
              </th>
              {this.props.editing && (
                <th className="uk-table-shrink">
                  <IntlText id="lists.articles.action" />
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {this.props.articles.map((article, key) => {
              const data = Formatter.mergeDesc(
                article,
                article.article_descs,
                lang,
              );
              return (
                <tr key={key}>
                  <td>
                    <div className="uk-width-small">
                      {data.posted_at &&
                        moment(data.posted_at).format("YYYY-MM-DD")}
                    </div>
                  </td>
                  <td>
                    <div className="uk-width-small">
                      <Image className="uk-width-1-1" src={data.thumnail_url} />
                    </div>
                  </td>
                  <td>
                    {data.status == 0 ? (
                      <span className="uk-label uk-background-secondary uk-light">
                        <IntlText id="lists.articles.private" />
                      </span>
                    ) : (
                      <span className="uk-label">
                        <IntlText id="lists.articles.public" />
                      </span>
                    )}
                    <h3 className="uk-margin-ssmall">{data.title}</h3>
                  </td>
                  {this.props.editing && (
                    <td>
                      <div className="uk-width-small uk-text-center">
                        <Link
                          className="uk-icon-button uk-button-default uk-margin-small-right"
                          data-uk-icon="icon:pencil;"
                          onClick={() => {
                            this.props.onEdit && this.props.onEdit(data);
                          }}
                        />
                        <Link
                          className="uk-icon-button uk-button-danger"
                          data-uk-icon="icon:close;"
                          onClick={() => {
                            this.props.onDelete && this.props.onDelete(data);
                          }}
                        />
                      </div>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    language: state.language,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({}, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ArticlesList),
);
